export function validateArrayType(value: any | any[]): any[] {
  if (Array.isArray(value)) {
    return value;
  }
  return value ? [value] : [];
}
